// alwaysShowMinutes=true: "0m 05s" (used for KPI/card displays)
// alwaysShowMinutes=false: "05s" when under a minute (used for per-student time rows)
export function formatDuration(ms: number, alwaysShowMinutes = true): string {
  const totalSec = Math.floor(ms / 1000);
  const mins = Math.floor(totalSec / 60);
  const secs = totalSec % 60;
  const ss = String(secs).padStart(2, "0");
  return !alwaysShowMinutes && mins === 0 ? `${ss}s` : `${mins}m ${ss}s`;
}

export function formatLastSaved(date: Date | null | undefined): string {
  if (!date) return "Not saved";
  const diff = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diff < 5) return "Just saved";
  if (diff < 60) return `${diff}s ago`;
  return `${Math.floor(diff / 60)}m ago`;
}
